import React, { useEffect, useState } from "react";
import { supabase } from "../supabaseClient";
import { Link } from "react-router-dom";
import "./components.css";

export default function EventGrid() {
  const [events, setEvents] = useState([]);
  const [filteredEvents, setFilteredEvents] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [sortBy, setSortBy] = useState("latest");
  const [searchQuery] = useState("");
  const [loading, setLoading] = useState(true); // initially true


  useEffect(() => {
  const fetchEvents = async () => {
    setLoading(true); // start loading
    const { data, error } = await supabase
      .from("events")
      .select("id, tittle, description, location, image_url, price, time, category, date");

    if (error) {
      console.error("Error fetching events:", error.message);
    } else {
      setEvents(data);
      setFilteredEvents(data);

      const uniqueCategories = [...new Set(data.map((event) => event.category))];
      setCategories(uniqueCategories);
    }
    setLoading(false); // finished loading
  };

  fetchEvents();
}, []);


  // Filter, sort, and search
  useEffect(() => {
    let filtered = [...events];

    if (selectedCategory !== "All") {
      filtered = filtered.filter((event) => event.category === selectedCategory);
    }
    if (searchQuery.trim() !== "") {
      const lowerQuery = searchQuery.toLowerCase();
      filtered = filtered.filter(
        (event) =>
          event.tittle.toLowerCase().includes(lowerQuery) ||
          event.location.toLowerCase().includes(lowerQuery) ||
          event.description.toLowerCase().includes(lowerQuery)
      );
    }

    if (sortBy === "latest") {
      filtered.sort((a, b) => new Date(b.date) - new Date(a.date));
    } else if (sortBy === "price-low") {
      filtered.sort((a, b) => a.price - b.price);
    } else if (sortBy === "price-high") {
      filtered.sort((a, b) => b.price - a.price);
    }

    setFilteredEvents(filtered);
  }, [events, selectedCategory, searchQuery, sortBy]);

  return (
    <div className="event-grid-wrapper">

      <section className="event-filters">
        <div className="event-filters-inner">
          <div className="filter-block">
            <label htmlFor="category">Category</label>
            <select id="category" value={selectedCategory} onChange={(e) => setSelectedCategory(e.target.value)}>
              <option value="All">All</option>
              {categories.map((cat) => (
                <option key={cat} value={cat}>{cat}</option>
              ))}
            </select>
          </div>

          <div className="filter-block">
            <label htmlFor="sort">Sort By</label>
            <select id="sort" value={sortBy} onChange={(e) => setSortBy(e.target.value)}>
              <option value="latest">Latest</option>
              <option value="price-low">Price: Low to High</option>
              <option value="price-high">Price: High to Low</option>
            </select>
          </div>
        </div>
      </section>


      <div className="grid">
  {loading ? (
    <div className="loader"></div>
  ) : filteredEvents.length > 0 ? (
    filteredEvents.map((item) => (
      <Link to={`/event/${item.id}`} key={item.id} className="event-card-link">
        <div className="events-wrapper">
          <div className="eventcard">
            <img
              src={item.image_url || "https://via.placeholder.com/300x200"}
              alt={item.tittle}
              className="event-image"
            />
            <div className="event-details">
              <h3 className="event-title">{item.tittle}</h3>
              <p className="event-date">{item.date}</p>
              <p className="event-time">{item.time}</p>
              <p className="event-location">{item.location}</p>
              <p className="event-price">Ksh.{item.price}</p>
            </div>
          </div>
        </div>
      </Link>
    ))
  ) : (
    <p>No events found.</p>
  )}
</div>

    </div>
  );
}
